import React from 'react';

import type { DirectLink } from '@src/core/buyerApiClient';
import { useTranslate } from '@src/core/hooks';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';
import {
  SummaryHeaderCard,
  SummaryHeaderTitle,
  SummaryHeaderTitleRow,
  SummaryRoot,
  SummarySection,
  SummaryTotalLabel,
  SummaryTotalRow,
  SummaryTotalValue,
} from '@src/features/cart';

type DirectLinkPaymentSummaryProps = {
  directLink: DirectLink;
};

export const DirectLinkPaymentSummary = (props: DirectLinkPaymentSummaryProps) => {
  const { directLink } = props;
  const { i18n } = useTranslate();
  const { formatCurrencyInfo } = useCurrencyFormat();

  return (
    <SummaryRoot data-testid='direct-link-payment-summary'>
      <SummaryHeaderCard>
        <SummaryHeaderTitleRow>
          <SummaryHeaderTitle>{i18n('direct_link_summary_title_payment')}</SummaryHeaderTitle>
        </SummaryHeaderTitleRow>

        <SummarySection>
          <SummaryTotalRow>
            <SummaryTotalLabel>{i18n('direct_link_summary_total')}</SummaryTotalLabel>
            <SummaryTotalValue>{formatCurrencyInfo(directLink.totalAmountCurrencyInfo)}</SummaryTotalValue>
          </SummaryTotalRow>
        </SummarySection>
      </SummaryHeaderCard>
    </SummaryRoot>
  );
};

export default DirectLinkPaymentSummary;
